<div class="import-section">
  <span>{{ "bastidores.import_description" | translate }}</span>

  <div class="drop-zone" [ngClass]="{ 'over': isDragOver }"
    (drop)="onDrop($event)" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)" (click)="fileInput.click()">
    {{ "forms.labels.draganddrop" | translate }}
    <input #fileInput type="file" class="input-file-hidden" accept=".xlsx,.xls,.csv" (change)="onFileInputChange($event)" />
  </div>

  <div class="import-info">
    <p class="import-notice">{{ "bastidores.import_create_only_notice" | translate }}</p>
    <p>{{ "bastidores.import_columns_info" | translate }}</p>
    <ul>
      <li><strong>vin</strong> - {{ "bastidores.vin" | translate }} ({{ "bastidores.import_required" | translate }})</li>
      <li><strong>license_plate</strong> - {{ "bastidores.license_plate" | translate }}</li>
      <li><strong>supplier_reference</strong> - {{ "bastidores.supplier_reference" | translate }}</li>
      <li><strong>colour</strong> - {{ "bastidores.colour" | translate }}</li>
      <li><strong>vehicle_discount_code</strong> - {{ "bastidores.vehicle_discount_code" | translate }}</li>
      <li><strong>workshop_id</strong> - {{ "bastidores.workshop" | translate }}</li>
      <li><strong>workshop_name</strong> - {{ "bastidores.workshop_name_import" | translate }}</li>
      <li><strong>dealership_id</strong> - {{ "bastidores.dealership_id_import" | translate }}</li>
      <li><strong>dealership_name</strong> - {{ "bastidores.dealership_name_import" | translate }}</li>
      <li><strong>manufacture_expected_date</strong> - {{ "bastidores.manufacture_expected_date" | translate }}</li>
      <li><strong>state</strong> - {{ "bastidores.state" | translate }} (factory / countryside)</li>
      <li><strong>manufacturer_state</strong> - {{ "bastidores.external_state_import" | translate }}</li>
      <li><strong>notes</strong> - {{ "bastidores.notes_import" | translate }}</li>
      <li><strong>delete</strong> - {{ "bastidores.delete_import" | translate }}</li>
      <li><strong>campaign_stock_id</strong> - {{ "bastidores.campaign_stock_id_optional" | translate }}</li>
    </ul>
  </div>
</div>
